import { slideToggle } from "./helper/slide-toggle";
// import { classExists } from "./helper/class-exists";
// import { clickButton } from "./helper/click-button";
import Swiper from "swiper";

const selectors = {
  body: document.querySelector("body"),
  header: document.querySelector("header"),
  nav: document.querySelector("nav"),
  utils: document.querySelector(".nav-utils"),
  menuBtn: document.querySelector(".js-menu-btn"),
  searchBtn: document.querySelector(".js-search-btn"),
  megaMenus: document.querySelectorAll(".js-caret-children"),
  userMenu: document.querySelector(".js-user-menu"),
  dropdowns: document.querySelectorAll(".has-dropdown"),
};

const removeClassesDetect = () => {
  const { body, header, nav, utils, menuBtn, searchBtn } = selectors;

  body.classList.remove("body-fixed");
  utils.classList.remove("burger-active", "search-results-active");
  header.classList.remove("search-active", "user-active");
  nav.classList.remove("is-open");
  menuBtn.classList.remove("active", "hidden");
  searchBtn.classList.remove("hidden");
  // userElem.classList.remove("hidden", "is-active");
};

const detectWindow = () => {
  const windowMedia = window.matchMedia("(min-width: 1024px)");
  // const { body, header, nav, utils, menuBtn, searchBtn, megaMenus, userMenu } = selectors;
  const { body, megaMenus } = selectors;

  if (windowMedia.matches && body.classList.contains("mobile-active")) {
    body.classList.remove("mobile-active");
    removeClassesDetect();

    megaMenus.forEach((megaMenu) => {
      megaMenu.removeAttribute("style");
    });
    // console.log("desktop");
  }

  if (!windowMedia.matches && !body.classList.contains("mobile-active")) {
    body.classList.add("mobile-active");
    removeClassesDetect();

    megaMenus.forEach((megaMenu) => {
      if (megaMenu.classList.contains("is-open")) {
        megaMenu.style["box-sizing"] = "border-box";
        megaMenu.style["display"] = "block";
      }
    });
  }
};

const scrollUpDown = () => {
  let lastScroll = 0;
  const { body, header } = selectors;

  window.onscroll = function () {
    let currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop;

    if (currentScroll > 0 && lastScroll <= currentScroll) {
      lastScroll = currentScroll;
      if (!body.classList.contains("body-fixed")) {
        header.classList.add("is-scrolling");
      }
    } else {
      lastScroll = currentScroll;
      header.classList.remove("is-scrolling");
    }
  };
};

const menuBurgerRemove = () => {
  const { body, header, utils } = selectors;
  utils.classList.remove("search-results-active");
  header.classList.remove("search-active");
  body.classList.remove("body-fixed");
};

const menuBurger = () => {
  const { body, nav, utils, menuBtn, searchBtn } = selectors;

  menuBtn.addEventListener(
    "click",
    function () {
      if (
        !body.classList.contains("mobile-active") &&
        utils.classList.contains("search-results-active")
        // || header.classList.contains("user-active")
      ) {
        menuBtn.classList.remove("active");
      } else {
        menuBtn.classList.toggle("active");
      }

      //mobile
      if (
        body.classList.contains("mobile-active") &&
        !utils.classList.contains("search-results-active")
        //  && !header.classList.contains("user-active")
      ) {
        nav.classList.toggle("is-open");
        body.classList.toggle("body-fixed");
        searchBtn.classList.toggle("hidden");
        // userElem.classList.toggle("hidden");
      }

      if (
        body.classList.contains("mobile-active") &&
        utils.classList.contains("search-results-active")
      ) {
        menuBurgerRemove();
      }

      // if (
      //   body.classList.contains("mobile-active") &&
      //   header.classList.contains("user-active")
      // ) {
      //   header.classList.remove('user-active');
      //   userElem.classList.remove('is-active');
      // }

      //desktop
      if (
        !body.classList.contains("mobile-active") &&
        !utils.classList.contains("search-results-active")
      ) {
        utils.classList.toggle("burger-active");
      }

      if (
        !body.classList.contains("mobile-active") &&
        utils.classList.contains("search-results-active")
      ) {
        menuBurgerRemove();
      }
    },
    false
  );

  document.addEventListener("click", (event) => {
    const megaMenuDesktop = document.querySelector(".js-mega-menu");

    const { utils, menuBtn } = selectors;

    if (!utils || !utils.classList.contains("burger-active")) return;

    if (event.target === menuBtn || menuBtn.contains(event.target)) return;

    const isOutside =
      megaMenuDesktop && !megaMenuDesktop.contains(event.target);

    if (isOutside) {
      menuBtn.click();
    }
  });
};

const menuBtnChild = () => {
  const buttons = document.querySelectorAll(".js-caret-button");
  const childElem = document.querySelectorAll(".js-caret-children");

  buttons.forEach((button, i) => {
    button.addEventListener("click", function (event) {
      slideToggle(childElem[i], 500);
      button.classList.toggle("is-open");
      childElem[i].classList.toggle("is-open");
    });
  });
};

const searchBtn = () => {
  const { body, header, nav, utils, menuBtn, searchBtn } = selectors;

  searchBtn.addEventListener(
    "click",
    function () {
      utils.classList.remove("burger-active");
      menuBtn.classList.add("active");
      header.classList.add("search-active");
      body.classList.add("body-fixed");
      utils.classList.add("search-results-active");
    },
    false
  );

  document.addEventListener("click", (event) => {
    const searchResult = document.querySelector(".search-results");

    if (!utils || !utils.classList.contains("search-results-active")) return;
    if (event.target === menuBtn || menuBtn.contains(event.target)) return;
    if (event.target === searchBtn || searchBtn.contains(event.target)) return;

    const isOutside = searchResult && !searchResult.contains(event.target) && nav && !nav.contains(event.target);

    if (isOutside) {
      menuBtn.click();
    }
  });
};

const hoverTimeout = (elemOne, elemTwo) => {
  setTimeout(function () {
    if (
      !elemOne.classList.contains("mobile-active") &&
      !elemTwo.matches(":hover")
    ) {
      elemTwo.classList.remove("is-active");
    }
  }, 200);
};

const hoverHasChildren = () => {
  const { body, menuBtn, dropdowns } = selectors;

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("mouseover", function () {
      if (!body.classList.contains("mobile-active")) {
        dropdown.classList.add("is-active");

        if (menuBtn.classList.contains("active")) {
          menuBtn.click();
        }
      }
    });

    dropdown.addEventListener("mouseout", function () {
      hoverTimeout(body, dropdown);
    });

    dropdown.addEventListener("mouseleave", function () {
      hoverTimeout(body, dropdown);
    });
  });
};

const closeChildren = () => {
  const { utils, menuBtn, dropdowns } = selectors;
  const closeBtn = utils.querySelector(".close-button");

  if (closeBtn) {
    closeBtn.addEventListener("click", function (event) {
      menuBtn.click();
    });
  }

  dropdowns.forEach((dropdown) => {
    const menuParentButton = dropdown.querySelector(".close-button");

    if (typeof menuParentButton != "undefined" && menuParentButton != null) {
      menuParentButton.addEventListener("click", function (event) {
        dropdown.classList.remove("is-active");
      });
    }
  });
};

let swiperMenuInit = false;

const swiperMenuBuild = (element) => {
  const categoryMenu = element.parentNode.querySelector(".category-menu");
  const categoryButton = categoryMenu.querySelectorAll("li");
  return new Swiper(element, {
    direction: "vertical",
    spaceBetween: 24,
    autoHeight: true,
    allowTouchMove: false,
    on: {
      init: (swiper) => {
        let allSlides = swiper.slides;
        let maxHeight = 0;
        for (let i = 0; i < allSlides.length; i++) {
          if (allSlides[i].offsetHeight > maxHeight) {
            maxHeight =
              allSlides[i].querySelector(".submenu-list").offsetHeight;
          }
        }
        const containerHeight = maxHeight;
        swiper.el.style.height = containerHeight + "px";
        for (let i = 0; i < categoryButton.length; i++) {
          const button = categoryButton[i];
          button.addEventListener("mouseover", function (event) {
            for (let x = 0; x < categoryButton.length; x++) {
              categoryButton[x].classList.remove("active-button");
            }
            button.classList.add("active-button");
            swiper.slideTo(i);
          });
        }
      },
    },
  });
};

const closeSearch = () => {
  const button = document.querySelector(".js-close-search");
  const { menuBtn } = selectors;

  if (button) {
    button.addEventListener("click", function (event) {
      menuBtn.click();
    });
  }
};

const swiperMenu = () => {
  let swiperMenus = document.querySelectorAll(".js-swiper-menu");
  const windowMedia = window.matchMedia("(min-width: 1024px)");

  if (windowMedia.matches) {
    if (!swiperMenuInit) {
      swiperMenuInit = true;
      swiperMenus.forEach((item) => {
        const slider = swiperMenuBuild(item);
      });
    }
  } else {
    swiperMenus.forEach((item) => {
      if (item.swiper) item.swiper.destroy(true, true);
    });
    swiperMenuInit = false;
  }
};

const changeLangDropdown = () => {
  let langDropdownSwitchers = document.querySelectorAll(".language-switcher");
  if (langDropdownSwitchers.length > 0) {
    langDropdownSwitchers.forEach((lds) => {
      lds.addEventListener("change", (event) => {
        let selectedLangSite = event.target.value;
        location.href = selectedLangSite;
      });
    });
  }
};

const menuScrollInit = () => {
  scrollUpDown();
};

// const userMenu = () => {
//   const { body, header, menuBtn, userMenu } = selectors;

//   classExists(userMenu);

//   if (userMenu) {
//     userMenu.addEventListener("mouseover", function () {
//       if (!body.classList.contains("mobile-active")) {
//         userMenu.classList.add("is-active");

//         // if (menuBtn.classList.contains("active")) {
//         //   menuBtn.click();
//         // }
//       }
//     });

//     userMenu.addEventListener("mouseout", function () {
//       setTimeout(function () {
//         if ( !body.classList.contains("mobile-active") && !userMenu.matches(":hover") ) {
//           userMenu.classList.remove("is-active");
//         }
//       }, 200);
//     });

//     userMenu.addEventListener("mouseleave", function () {
//       setTimeout(function () {
//         if ( !body.classList.contains("mobile-active") && !userMenu.matches(":hover") ) {
//           userMenu.classList.remove("is-active");
//         }
//       }, 200);
//     });

//     clickButton([menuBtn], () => {
//       if (body.classList.contains("mobile-active")) {
//         userMenu.classList.add("is-active");
//         body.classList.add("body-fixed");
//         menuBtn.classList.add("active");
//         header.classList.add("user-active");
//       }
//     });
//   }
// };

const menuInit = () => {
  menuScrollInit();
  menuBurger();
  searchBtn();
  hoverHasChildren();
  closeChildren();
  menuBtnChild();
  closeSearch();
  changeLangDropdown();
  // userMenu();
};

document.addEventListener("DOMContentLoaded", function () {
  detectWindow();
  menuInit();
  swiperMenu();
});

window.addEventListener(
  "resize",
  function (event) {
    detectWindow();
    swiperMenu();
  },
  true
);
